export enum NotificationType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
  ALERT = 'ALERT'
}

export interface AppNotification {
  id: string;
  title: string;
  message: string;
  type: NotificationType;
  recipientRole: string;
  isRead: boolean;
  createdAt: Date;
  actionUrl?: string;
}
